import { useMutation } from '@tanstack/react-query'
import { authService } from '../../service/domain/_service.config'

export function useUpdatePassword() {
  return useMutation({
    mutationFn: async (password: string) => {
      await authService.updatePassword(password)
    },
  })
}
